import classNames from 'classnames';
import type { BetaPillProps } from './types';

export const BetaPill: React.FC<BetaPillProps> = ({ className }) => {
  return <div className={classNames('beta-pill', className)}>Beta</div>;
};
